import moment from 'moment'
import { roundMomentToMinutes } from './round-moment-to-minutes'

/**
 * Takes a Date and returns it's ISO representation (precision is minutes).
 * Date is rounded to closest full minute. So if the time is 9:30:23 it's rounded
 * down to 9:30, if the time is 9:30:37 it's rounded up to 9:31. This is also
 * important because of the DatePicker returning ranges like
 * "2016-08-01 00:00:00 - 2016-08-03 23:59:59" (which unfortunately cannot
 * easily be changed right now).
 *
 * @deprecated The only use case for this function seems to be setting the registrationDate for an object (vehicle).
 * The WASAPI endpoint (/objects/{objectId}/details) only accepts strings of a limited length, which is why
 * the timestamp is rounded and shortened (See bug ticket ATL-4388.) I will remove the usage of this function
 * in Atlantis and Shared Modules.
 * Generally timestamps should be sent to APIs in UTC time zone and formatted as ISO-8601 string. For other
 * cases that require a custom string format, please use one of the other formatters or {@link toCustomDatetimeString}.
 *
 * @function
 * @param {Date} date - `Date` instance to be converted
 * @param {boolean} [round=true] - Should the date be rounded (or just trim seconds/millis)
 * @param {boolean} [useFormat=false] - Whether to use with toISOString() or not
 * @return {string} ISO formatted string including date and time (time as HH:mm)
 */
export function dateToCustomPrecisionISO(date, round = true, useFormat = false) {
    const mom = moment(date)
    const momUTC = moment(date).utc()
    let maxPrecisionISO

    if (useFormat) {
        // There is an issue with moment and toISOString getting the wrong date.
        // @see https://github.com/moment/moment/issues/947
        const isoFormat = 'YYYY-MM-DD[T]HH:mm:ss.SSS'
        maxPrecisionISO = round ? roundMomentToMinutes(mom).format(isoFormat) : mom.format(isoFormat)
    } else {
        maxPrecisionISO = round ? roundMomentToMinutes(momUTC).toISOString() : momUTC.toISOString()
    }

    return maxPrecisionISO.replace(/T([0-9]+:[0-9]+).*$/, 'T$1')
}
